// No imports: the designer page bundles this file too, so the page and the server judge transfers alike.

// DTF transfers on the designer (designer-decisions.md section E). A gang sheet is printerMaxWidthIn x maxLengthIn
// (print_rules); prices are prices.transfers. A transfer prints exactly as uploaded, so under minDpi is refused.
export const TRANSFER_LIMITS = { maxPieces: 500, maxGangSheets: 100, gangRatioTolerance: 0.02, minDpi: 150, sharpDpi: 300 } as const;

export type TransferKind = "piece" | "gang";

// A gang sheet must be laid out in the sheet's shape: its height over width within 2% of the sheet's.
// The 1e-9 absorbs floating-point noise, so a sheet exactly 2% off (3600 x 5508 px) is still within 2%.
export function gangRatioOk(widthPx: number, heightPx: number, sheetWidthIn: number, sheetHeightIn: number): boolean {
  if (!(widthPx > 0 && heightPx > 0 && sheetWidthIn > 0 && sheetHeightIn > 0)) return false;
  return Math.abs(heightPx / widthPx / (sheetHeightIn / sheetWidthIn) - 1) <= TRANSFER_LIMITS.gangRatioTolerance + 1e-9;
}

// "24 DTF transfers, 10 x 5 in" or "1 gang sheet, 12 x 18 in": the page, the share page, the email, Slack and the
// portal all word a transfer order this way.
export function transferLine(t: { kind: TransferKind; widthIn: number; heightIn: number; quantity: number }): string {
  const one = t.quantity === 1;
  const what = t.kind === "gang" ? (one ? "gang sheet" : "gang sheets") : one ? "DTF transfer" : "DTF transfers";
  return `${t.quantity} ${what}, ${t.widthIn} x ${t.heightIn} in`;
}

export function fulfillmentText(f: "pickup" | "ship"): string {
  return f === "ship" ? "Shipped, included in the estimate" : "Pickup in Altoona, free";
}
